<template>
  <div>
    <the-header></the-header>
    <div class="flex">
      <div class="page-main-content max-w-none flex-auto mx-auto">
        <div class="mx-auto px-8 py-3.5">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <loading v-model:active="isCallingApi" :is-full-page="isLoadingFullPage"></loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TheHeader from '@/member/components/common/TheHeader'

export default {
  name: 'MainContentLayout',
  components: { TheHeader },
  computed: {
    ...mapGetters(['isCallingApi', 'isLoadingFullPage']),
  },
}
</script>

<style scoped>

</style>
